import React, { useState } from "react";

// Buat context
const GlobalContext = React.createContext();

// Buat provider
export const GlobalProvider = ({ children }) => {
  const [user, setUser] = React.useState({ name: "John Doe", age: 25 });
  const [paket, setpaket] = React.useState({});

  const value = {
    user,
    setUser,
    paket,
    setpaket,
  };

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};

// Export context untuk digunakan di komponen lain
export default GlobalContext;
